import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TileComponent } from "./tile.component";
import { BarHeadlineModule } from "../bar-headline/bar-headline.module";
import { ArrowLinkModule } from "../arrow-link/arrow-link.module";

@NgModule({
  imports: [
    CommonModule,
    BarHeadlineModule,
    ArrowLinkModule
  ],
  declarations: [TileComponent],
  exports: [TileComponent]
})
export class TileModule { }
